import { Card, CardContent } from '@/components/ui/card';
import { BASIC_METRICS } from '@/constants/metrics';

const advancedMetrics = [
  'CAC (Custo de Aquisição)',
  'LTV (Lifetime Value)',
  'Ticket Médio',
  'Churn Detalhado',
  'Cohort Analysis',
  'Previsão de Receita',
  'Análise de Retenção',
  'ROI por Canal',
];

export function MetricsSection() {
  return (
    <section className="py-20 md:py-32">
      <div className="container mx-auto px-4">
        <div className="mx-auto max-w-2xl text-center space-y-4 mb-16">
          <h2 className="text-3xl md:text-4xl font-bold">
            Mais de 15 métricas para decisões baseadas em dados
          </h2>
          <p className="text-xl text-muted-foreground">
            Todas as métricas que você precisa para gerenciar seu negócio SaaS
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {/* Basic Metrics */}
          <Card>
            <CardContent className="p-6 space-y-4">
              <h3 className="text-xl font-semibold mb-4">Métricas Básicas</h3>
              <ul className="space-y-3">
                {BASIC_METRICS.map((metric) => (
                  <li key={metric} className="flex items-center gap-2">
                    <div className="h-2 w-2 rounded-full bg-primary" />
                    <span>{metric}</span>
                  </li>
                ))}
              </ul>
            </CardContent>
          </Card>

          {/* Advanced Metrics */}
          <Card>
            <CardContent className="p-6 space-y-4">
              <h3 className="text-xl font-semibold mb-4">Métricas Avançadas</h3>
              <ul className="space-y-3">
                {advancedMetrics.map((metric) => (
                  <li key={metric} className="flex items-center gap-2">
                    <div className="h-2 w-2 rounded-full bg-primary" />
                    <span>{metric}</span>
                  </li>
                ))}
              </ul>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
}
